import React from 'react';
import RoleBasedRoute from './RoleBasedRoute';

/**
 * Protected route specifically for Raise Your Voice users
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - The protected component or redirect
 */
const RaiseYourVoiceRoute = ({ children }) => {
  return (
    <RoleBasedRoute 
      allowedRoles="ryvuser" 
      redirectPath="/raise/login"
    >
      {children}
    </RoleBasedRoute>
  );
};

export default RaiseYourVoiceRoute;
